var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"pill":"","variant":"dark"}},[_vm._v(" "+_vm._s(_vm.requestUuidsByRealisationUuid({ uuid: _vm.value }).length || 0)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }